/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { Fragment, useContext, useState ,useEffect, useRef} from 'react';
import SidePopup from '../../SidePopup';
import GlobalContext from '../../Context/GloablContext';
import Input from '../../InputBox';
import UpdateButton from '../../UpdateButton';
import { dataService } from '../../../services/data.services';
import { ConvertToTitleCase } from '../../../CommonMethods/ConvertToTitleCase';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { countWords } from '../../../CommonMethods/WordCount';

const EditClass = ({
    handleSidePopupClick, 
    getBranch,
    addOpen, 
    inputValue,
    setInputValue,
    handleLoadData,
    sideModelType,
    editValue,
    handleName,
    type,
    setEditOpen,
    handleEndpoint
}) => {
    const [submitSelected, setsubmitSelected] = useState(false);
    const {setToastmessage, setToastErrorMessage,toastErrorMessage,Toastmessage} =useContext(GlobalContext)
    const initialError = {
        admin_first_name : false,
        admin_email_address: false,
        admin_mobile_number: false,
        roles: false,
        email_validation: false,
        mobile_validation : false,
    }
    const [actionErrorMessage, setActionErrorMessage] = useState("")
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState({name: false, description : false})
    const handleInput=(e)=>{
        const {id,value}=e.target;
        setErrorMessage({name: false, description : false})
        const wordCount = countWords(value)
        if(id === "description") {
            if(wordCount > 100 ) {
                setErrorMessage((prv)=>({
                    ...prv,
                    [id]: true
                }))
                setActionErrorMessage('Description cannot exceed 100 words'); 
                if (wordCount > 100) {
                    return; // Stop further input beyond 100 words
                }
            }
            setInputValue((prv)=>({
                ...prv,
                [id]: value
            }))
        } else {
            setInputValue((prv)=>({
                ...prv,
                [id]:value
            }))
        }
        
    }
    useEffect(() => {
    
        return () => {
            setEditOpen(false)
        }
    }, [])
    
    const handleSubmit = async () => {
        setLoading(true);
        if(inputValue.name === '') {
            setErrorMessage((prv)=>({
                ...prv,
                ["name"]: true
            }))
            setsubmitSelected(true)
            setActionErrorMessage("Please fill in all the mandatory fields")
            setLoading(false);
        } else {
            try {
                let body = { }
                const branch_id = await GetBranchId()
                body = {
                    "status": inputValue.status,
                    "name": inputValue.name.trim(),
                    "description": inputValue.description,
                    "branch_id" : branch_id
                }
                if(sideModelType === "Subject") {
                    body["is_optional"] = inputValue.is_optional
                }
                try {
                    let endpoint= `${handleEndpoint(type)}/${inputValue._id}`
                    const response = await dataService.PatchAPI(body,endpoint);
                    setEditOpen(false)
                    handleSidePopupClick();
                    setToastmessage(`${ConvertToTitleCase(handleName(type))} updated successfully`);
                    getBranch('no')
                } catch (error) {
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    setLoading(false);
                }
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                setLoading(false);
            }
            
        }
    }
    const ref=useRef();
    useOnClickOutside(ref,()=>{
        if(Toastmessage!=='' | toastErrorMessage!==''){
            setEditOpen(false)

        }
    })
    return (
        <>
            <SidePopup 
                addOpen={true}
                class="bg-''"
                componentName={`Edit ${sideModelType}`}
                handleSidePopupClick={handleSidePopupClick}
                actionErrorMessage={actionErrorMessage}
                setActionErrorMessage={setActionErrorMessage}
                element={
                    <div class="offcanvas-body px-6 pb-5 mt-7" ref={ref}>
                        <form action="#">
                            <div class="w-full flex">
                                <div class="w-1/2 items-center">
                                    <label for="class-name" class="text-f7 font-normal text-[#031624] class-name-error">{sideModelType} Name</label>                             
                                    <Input
                                        type="text"
                                        state={inputValue}
                                        id="name"
                                        test_id = {"fname0"}
                                        maxLength={30}
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        customError={errorMessage.name ? ['name'] : []}
                                        className="w-full outline-0 bg-white border border-[#D0D5DD] rounded px-3.5 py-1 mt-1 red-border"                                     
                                        text="Address Line 1 name is mandatory"
                                        placeholder ={`Enter ${sideModelType} Name`}
                                    />
                                </div>
                                <div class="w-1/2 ml-4">
                                    <label for="clock_in_out" class="switch text-f7 font-normal text-[#000000] slider">Status</label>
                                    <div class="status custom-toggle flex items-center mt-2.5">
                                        <label class="switch" style={{marginLeft: "10px"}}>
                                            <input 
                                                type="checkbox"
                                                id="checked"
                                                checked={inputValue.status}
                                                onChange={() => setInputValue((prv)=>({
                                                    ...prv,
                                                    ["status"]: !inputValue.status
                                                }))}
                                            /><span class="slider round"></span>
                                        </label>
                                        <p class="ml-2">
                                            <span class={`"text-f7 font-normal ${inputValue.status ? "text-[#106EB4]" : "text-[#344054] "} disable_switch"`}>{inputValue.status ? "Active" : "Inactive"}</span> 
                                            <span class="textt-f7 font-normal  hidden switch_enabled">Active</span>
                                        </p>
                                    </div>   
                                </div>
                            </div>
                            <div class="mt-4 border-b border-[D0D5DD] pb-6">
                                <label for="Description" class="text-f7 font-normal text-[#031624] descri-error">Description</label>
                                <div class={`${errorMessage.description ? 'border-[#F04438]' : 'border-[#D0D5DD]'} pr-1 overflow-auto border  red-border1 rounded w-full mt-1.5`}>
                                    <textarea
                                        id="description"
                                        data-testid = "description"
                                        value={inputValue.description}
                                        onChange={(e) => handleInput(e)}
                                        class="w-full overflow-auto scroll-gray pt-2 px-2.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] resize-none h-[45px]" placeholder="Enter Description"></textarea>
                                </div>
                                {sideModelType === "Subject" && <div className='mt-[25px]'>
                                            
                                    <div class="relative custom-radioBlue w-1/2 flex" >
                                        <input id="default-radio1" type="radio" value="2" name="default-radio"
                                            onChange={() => setInputValue((prv)=>({
                                                ...prv,
                                                ["is_optional"]: false
                                            }))} 
                                            checked={!inputValue.is_optional}
                                        />
                                        <label for="default-radio1" class="ml-[30px] text-f2 font-normal text-[#031624] cursor-pointer ledger-label">Mandatory</label>
                                    </div>
                                    <div class="relative custom-radioBlue w-1/2 flex">
                                        <input id="default-radio2" type="radio" value="2" name="default-radio" 
                                            onChange={() => setInputValue((prv)=>({
                                                ...prv,
                                                ["is_optional"]: true
                                            }))} 
                                            checked={inputValue.is_optional}/>
                                        <label for="default-radio2" class="ml-[30px] text-f2 font-normal text-[#031624] cursor-pointer ledger-label">Optional</label>
                                    </div>
                                </div>}
                            </div>
                            
                            <div class="flex -mx-2.5 mt-6">
                                <div class="w-1/2">
                                    <div class="w-full flex justify-end">
                                        <button onClick={() => handleSidePopupClick()} type="button" class="cancl-btn" data-te-modal-dismiss="" aria-label="Close">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div class="w-1/2">
                                    <div class="w-full">
                                        <UpdateButton
                                            ButtonName="Update"
                                            loading={loading}
                                            handleOnCLick={handleSubmit}
                                            classKey="actn-btn onboardInstitution"
                                        /> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
            />
        </>
    );
}

export default EditClass;
